import { render, staticRenderFns } from "./ExportProductionBitacora.vue?vue&type=template&id=520e472a&"
import script from "./ExportProductionBitacora.vue?vue&type=script&lang=js&"
export * from "./ExportProductionBitacora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports